import { render, staticRenderFns } from "./changepaypwd.vue?vue&type=template&id=bbfa3dc0&scoped=true"
import script from "./changepaypwd.vue?vue&type=script&lang=js"
export * from "./changepaypwd.vue?vue&type=script&lang=js"
import style0 from "./changepaypwd.vue?vue&type=style&index=0&id=bbfa3dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfa3dc0",
  null
  
)

export default component.exports